const WINDOW_NAME = "nhuiOrderHistory";

export const openOrderHistoryWindow = (orderNo = "") => {
  const query = orderNo ? `?orderNo=${encodeURIComponent(orderNo)}` : "";
  const popup = window.open(
    `/order-history-popup${query}`,
    WINDOW_NAME,
    "popup=yes,width=1400,height=720,resizable=yes,scrollbars=yes",
  );

  popup?.focus();
  return popup;
};

